export enum EnumColors {
    WHITE = "#fff",
    PURPLE_DARK = "#2A1A40",
    PURPLE_MIDLE = "#8469BF",
    PURPLE = "#D0C2FD",
    YELLOW = "#F2BE22",
    YELLOW_MIDLE = "#F2D47A",
    ORANGE = "#F8853D",
    RED = "#F44336",
    GREEN = "#6FBF73",
    BLUE = "#2A3EB1",
    GRAY = "#777",
    BLACK = "#000",
}
